import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import './App.css';
import { loginRequest, loginRequestValidateUserName } from './auth/authConfig';
import Content from "./components/content";
import Header from "./components/Header";
import * as constant from "./constants/Constant";
import { AccessContext } from "./models/accesscontrol/AccessContext";
import { IWidgetInfo } from "./models/accesscontrol/IWidgetInfo";
import { IMaintenanceExemptUser, IProspectUsersDetails, IWebViewMaintenanceSettings } from "./models/accesscontrol/ProspectUsersDetails";
import { WidgetMap } from "./models/accesscontrol/WidgetMap";
import { ProfileData } from "./pages/Authentication/ProfileData";
import { ProspectClientInformation } from "./pages/Authentication/ProspectClientInformation";
import Login from "./pages/Login";
import { LogoutSignin } from "./pages/LogoutSignin";
import MultiLocationDetails from "./pages/Settings/MultiLocation/MultiLocationDetails";
import { GlobalStateAction, useGlobalState } from "./store/GlobalStore";
import { useFetch, usePost } from './utils/apiHelper';
import { MaintenancePage } from "./pages/MaintenancePage";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      marginTop: '50px',
      width: '100%',
      whiteSpace: 'pre-wrap',
      overflowWrap: 'break-word'
    },
    image: {
      width: '80vw',
      height: '60vh',
      alignItems: "center",
    },
    MessageStyle: {
      marginTop: '25px',
      fontSize: '32px'
    }
  }),
);

function App() {
  const { dispatch } = useGlobalState();
  const { accounts, instance, inProgress } = useMsal();
  // const isAuthenticated = useIsAuthenticated();
  const [isValidUser, setValidateUser] = useState<boolean>(null);
  const [isDisable, setIsDisable] = useState(false);
  const [valUser, setValUser] = useState(false);
  const [newUserDetails, setNewUserDetails] = useState<IProspectUsersDetails>();
  const classes = useStyles();
  let history = useHistory();
  const [userName, setUserName] = useState<string>("");
  const authMethod = localStorage?.getItem("authMethod");
  let accountsDetails: any = localStorage.getItem("userDetails");
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || '{}');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [maintenanceSettings, setMaintenanceSettings] = useState<IWebViewMaintenanceSettings>(null);
  const [exemptUsers, setExemptUsers] = useState<IMaintenanceExemptUser[]>([]);

  useEffect(() => {
    setIsDisable(inProgress == 'login' || inProgress == 'handleRedirect' || inProgress == 'startup')
  }, [inProgress]);

  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };
  }, []);

  const fetchUserDetails = async (objectId) => {
    try {
      const response = await instance.acquireTokenSilent(loginRequestValidateUserName);

      if (!response.accessToken) {
        throw new Error("Access token not found");
      }
      const graphResponse = await fetch(`https://graph.microsoft.com/v1.0/users/${objectId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${response.accessToken}`,
          "Content-Type": "application/json"
        }
      });

      if (!graphResponse.ok) {
        throw new Error(`Failed to fetch user details. Status: ${graphResponse.status}`);
      }

      const userData = await graphResponse.json();

      // Return the username or email
      return userData;
    } catch (error) {
      console.error("Error fetching user details:", error);
      return ""; // Return empty string if there's an error
    }
  };


  useEffect(() => {
    if (isAuthenticated) {
      if (authMethod === "OTP") {
        fetchAndLoginWithOTP();
      } else {
        fetchAndLogin();
      }
    } else if (authMethod === "OTP") {
      fetchAndLoginWithOTP();
    }
  }, [isAuthenticated])

  useEffect(() => {
    const authMethod = localStorage.getItem("authMethod");
    const userToken = localStorage.getItem("userToken");

    if (authMethod === "OTP" && userDetails?.email && userToken) {
      setIsAuthenticated(true);
    } else if (accounts.length) {
      setIsAuthenticated(true);
    }
  }, [accounts, userDetails]);

  const fetchAndLogin = async () => {
    let account = accounts[0];
    let userObjectId = "";
    // If username is missing, fetch it from AD
    if (!account.username) {
      try {
        const userName = await fetchUserDetails(account.localAccountId);
        account.username = userName?.mail;
        userObjectId = userName?.id;
      } catch (error) {
        console.error("Failed to fetch username:", error);
        return; // Stop execution if username retrieval fails
      }
    }
    if (account.username) {
      instance.ssoSilent({ ...loginRequest, loginHint: account.username }).then(a => {
        dispatch({
          type: GlobalStateAction.LoggedIn, user: {
            id: account.homeAccountId ?? "",
            name: account.username ?? "",
            profileImage: "./images/header-logo.png",
            email: account.username ?? "",
            userToken: a.accessToken,
            homeAccountId: account.homeAccountId ?? "",
            localAccountId: account.localAccountId ?? "",
            objectId: a.uniqueId
          }
        });

        (async () => {
          setUserName(account?.username);
          let request = { "email": account.username }
          let newRequestValue = { "userName": account.username }
          await usePost<{ prospectUsersDetails: IProspectUsersDetails, maintenanceSettings: IWebViewMaintenanceSettings, exemptUsers: IMaintenanceExemptUser[] }>("User/GetNewUserDetails", newRequestValue).then(async (r) => {
            setExemptUsers(r?.data?.exemptUsers);
            setNewUserDetails(r?.data?.prospectUsersDetails);
            setMaintenanceSettings(r?.data?.maintenanceSettings);
            await usePost<any>("AgentUser/CheckAgentUser", request).then(async (r) => {
              setValUser(r?.data[0]?.isAgentUser);
              if (!r?.data[0]?.isAgentUser) {
                let UserValidate = { "userName": a.account?.username?.length > 0 ? a.account?.username : account.username, "objectId": a?.uniqueId?.length > 0 ? a.uniqueId : userObjectId }
                await usePost<any>("User/ValidateUserInvitation", UserValidate).then(async (userInvitation) => {
                  setValidateUser(userInvitation?.data);
                  if (userInvitation.data === true) {
                    let requestAccount = { "userName": a.account?.username?.length > 0 ? a.account?.username : account.username };
                    await usePost<AccessContext>("User/GetUserInfoByEmail", requestAccount).then(async (userAcc) => {
                      await useFetch<IWidgetInfo[]>("User/GetWidgetsForClient?userId=" + userAcc?.data?.id).then((clientsWidgets) => {
                        dispatch({ type: GlobalStateAction.SetPermissions, userAccessContext: userAcc.data });
                        if (userAcc?.data?.role == 0 || userAcc?.data?.role == 1) {
                          for (let index = 1; index <= WidgetMap.size; index++) {
                            const value = WidgetMap.get(index);
                            if (value && clientsWidgets.data.filter(w => w.widgetId === index).length === 1) {
                              userAcc.data[value] = true;
                            }
                            dispatch({ type: GlobalStateAction.SetPermissions, userAccessContext: userAcc.data });
                          };
                        };
                      });

                      if (window.document.location.href === constant?.reportSubRouteKey || window.document.location.href === constant?.reportSubRoute) {
                        history.push('/report');
                      } else if ((userAcc?.data.role !== 2 && userAcc?.data?.role !== 3) && (window.document.location.href === constant?.rollSubRouteKey || window.document.location.href === constant?.rollSubRoute) && (userAcc?.data?.rollAccounts === true)) {
                        history.push('/roll');
                      } else if (userAcc?.data?.role === 2 || userAcc?.data?.role === 3) {
                        history.push('/admin');
                      } else if ((userAcc?.data?.role === 0 || userAcc?.data?.role === 1) && userAcc?.data?.totalUserCount === 0) {
                        history.push('/dashboard');
                      } else if ((userAcc?.data?.role === 0 || userAcc?.data?.role === 1) && userAcc?.data?.totalUserCount > 0) {
                        history.push('/prospectUsersList');
                      }
                      else {
                        history.push('/ManageClientFolderAccess')
                      }

                      if (window.location.origin !== constant?.LocalHost) {
                        let request = {
                          "userName": a.account?.username?.length > 0 ? a.account?.username : account.username,
                          "loginDateTime": new Date(),
                          "userId": userAcc?.data?.id,
                          "userTypeId": 1
                        }
                        await usePost<any>("UserLoginHistory/InsertIAMLoginHistory", request);
                      }
                    });
                  }
                }).catch(() => {
                  setValidateUser(false);
                });
              }
              else {
                if (r?.data[0]?.isAgentInvited) {
                  setValidateUser(true);
                  let request = { "emailAddress": a.account?.username?.length > 0 ? a.account?.username : account.username }
                  await usePost<any>("AgentUser/GetAgentUserByEmail", request).then(async (r) => {
                    dispatch({ type: GlobalStateAction.AgentUserAccessContext, AgentUserAccessContext: r?.data['agentUserDetails'][0] });
                    dispatch({ type: GlobalStateAction.AgentClientDetails, AgentClientDetails: r?.data['agentUserClientPermissions'] });
                    dispatch({ type: GlobalStateAction.AgentUserNotificationClientCodeDetails, AgentUserNotificationClientCodeDetails: r?.data['notificationClientDetails'] });
                    if (r?.data['agentUserDetails'][0]?.disputeValidation || r?.data['agentUserDetails'][0]?.paymentVerification || r?.data['agentUserDetails'][0]?.backupDocument) {
                      history.push('/agentdashboard');
                    } else {
                      history.push('/agentinquiry');
                    }
                    if (window.location.origin !== constant?.LocalHost) {
                      let requestLogin = {
                        "userName": a.account?.username?.length > 0 ? a.account?.username : account.username,
                        "loginDateTime": new Date(),
                        "userId": r?.data['agentUserDetails'][0]?.agentUserId,
                        "userTypeId": 2
                      }
                      await usePost<any>("UserLoginHistory/InsertAgentUserLoginHistory", requestLogin);
                    }
                  });
                }
                else {
                  setValidateUser(false);
                }
              }
            });
          })
        })()
      });
    }
  }

  const fetchAndLoginWithOTP = async () => {
    let account: any = JSON.parse(localStorage.getItem("userDetails") || '{}');
    if (account?.email) {
      try {
        dispatch({
          type: GlobalStateAction.LoggedIn, user: {
            id: account?.objectId + "." + constant.tenantId,
            name: account?.userName,
            profileImage: "./images/header-logo.png",
            email: account?.email,
            userToken: account?.token,
            homeAccountId: account?.objectId + "." + constant.tenantId,
            localAccountId: account?.objectId,
            objectId: account?.objectId
          }
        });

        (async () => {
          setUserName(account?.email);
          let request = { "email": account.email }
          let newRequestValue = { "userName": account.email }
          await usePost<{ prospectUsersDetails: IProspectUsersDetails, maintenanceSettings: IWebViewMaintenanceSettings, exemptUsers: IMaintenanceExemptUser[] }>("User/GetNewUserDetails", newRequestValue).then(async (r) => {
            setExemptUsers(r?.data?.exemptUsers);
            setNewUserDetails(r?.data?.prospectUsersDetails);
            setMaintenanceSettings(r?.data?.maintenanceSettings);
            await usePost<any>("AgentUser/CheckAgentUser", request).then(async (r) => {
              setValUser(r?.data[0]?.isAgentUser);
              if (!r?.data[0]?.isAgentUser) {
                let UserValidate = { "userName": account?.email?.length > 0 ? account?.email : account.email, "objectId": account?.objectId }
                await usePost<any>("User/ValidateUserInvitation", UserValidate).then(async (userInvitation) => {
                  setValidateUser(userInvitation?.data);
                  if (userInvitation.data === true) {
                    let requestAccount = { "userName": account?.email?.length > 0 ? account?.email : account.email };
                    await usePost<AccessContext>("User/GetUserInfoByEmail", requestAccount).then(async (userAcc) => {
                      await useFetch<IWidgetInfo[]>("User/GetWidgetsForClient?userId=" + userAcc?.data?.id).then((clientsWidgets) => {
                        dispatch({ type: GlobalStateAction.SetPermissions, userAccessContext: userAcc.data });
                        if (userAcc?.data?.role == 0 || userAcc?.data?.role == 1) {
                          for (let index = 1; index <= WidgetMap.size; index++) {
                            const value = WidgetMap.get(index);
                            if (value && clientsWidgets.data.filter(w => w.widgetId === index).length === 1) {
                              userAcc.data[value] = true;
                            }
                            dispatch({ type: GlobalStateAction.SetPermissions, userAccessContext: userAcc.data });
                          };
                        };
                      });

                      if (window.document.location.href === constant?.reportSubRouteKey || window.document.location.href === constant?.reportSubRoute) {
                        history.push('/report');
                      } else if ((userAcc?.data.role !== 2 && userAcc?.data?.role !== 3) && (window.document.location.href === constant?.rollSubRouteKey || window.document.location.href === constant?.rollSubRoute) && (userAcc?.data?.rollAccounts === true)) {
                        history.push('/roll');
                      } else if (userAcc?.data?.role === 2 || userAcc?.data?.role === 3) {
                        history.push('/admin');
                      } else if ((userAcc?.data?.role === 0 || userAcc?.data?.role === 1) && userAcc?.data?.totalUserCount === 0) {
                        history.push('/dashboard');
                      } else if ((userAcc?.data?.role === 0 || userAcc?.data?.role === 1) && userAcc?.data?.totalUserCount > 0) {
                        history.push('/prospectUsersList');
                      }
                      else {
                        history.push('/ManageClientFolderAccess')
                      }

                      if (window.location.origin !== constant?.LocalHost) {
                        let request = {
                          "userName": account?.email > 0 ? account?.email : account.email,
                          "loginDateTime": new Date(),
                          "userId": userAcc?.data?.id,
                          "userTypeId": 1
                        }
                        await usePost<any>("UserLoginHistory/InsertIAMLoginHistory", request);
                      }
                    });
                  }
                }).catch(() => {
                  setValidateUser(false);
                });
              }
              else {
                if (r?.data[0]?.isAgentInvited) {
                  setValidateUser(true);
                  let request = { "emailAddress": account?.email?.length > 0 ? account?.email : account.email }
                  await usePost<any>("AgentUser/GetAgentUserByEmail", request).then(async (r) => {
                    dispatch({ type: GlobalStateAction.AgentUserAccessContext, AgentUserAccessContext: r?.data['agentUserDetails'][0] });
                    dispatch({ type: GlobalStateAction.AgentClientDetails, AgentClientDetails: r?.data['agentUserClientPermissions'] });
                    dispatch({ type: GlobalStateAction.AgentUserNotificationClientCodeDetails, AgentUserNotificationClientCodeDetails: r?.data['notificationClientDetails'] });
                    if (r?.data['agentUserDetails'][0]?.disputeValidation || r?.data['agentUserDetails'][0]?.paymentVerification || r?.data['agentUserDetails'][0]?.backupDocument) {
                      history.push('/agentdashboard');
                    } else {
                      history.push('/agentinquiry');
                    }
                    if (window.location.origin !== constant?.LocalHost) {
                      let requestLogin = {
                        "userName": account?.email?.length > 0 ? account?.email : account.email,
                        "loginDateTime": new Date(),
                        "userId": r?.data['agentUserDetails'][0]?.agentUserId,
                        "userTypeId": 2
                      }
                      await usePost<any>("UserLoginHistory/InsertAgentUserLoginHistory", requestLogin);
                    }
                  });
                }
                else {
                  setValidateUser(false);
                }
              }
            });
          })
        })()
      } catch (error) {
        console.error("Error during loginAndFetchUserDetails:", error);
      }
    }
  }

  if (isAuthenticated) {
    if (maintenanceSettings?.isWebViewDown && !(exemptUsers?.some(u => u.userEmailAddress === userName?.toLowerCase()))) {
      return (<MaintenancePage />);
    }
    if (isValidUser == null) {
      return (<Login isLoading={isDisable} isAuth={true} isAuthenticated={isAuthenticated} />)
    }
    else if (newUserDetails[0]?.isUserActivated === false) {
      return (<ProspectClientInformation userDetails={newUserDetails[0]} isPasswordProvided={false} />)
    }
    else if (newUserDetails[0]?.isNewOrginization && newUserDetails[0]?.isUserActivated && !newUserDetails[0]?.isClientInfoConfirmed && (newUserDetails[0]?.isMultiBranch != null || newUserDetails[0]?.isMultiBranch != undefined)) {
      return (<MultiLocationDetails userDetails={newUserDetails[0]} />)
    }
    else if (newUserDetails[0]?.isWebviewUser && newUserDetails[0]?.isNewOrginization && !newUserDetails[0]?.isUserActivated && !newUserDetails[0]?.isAdminApproved) {
      return (<ProspectClientInformation userDetails={newUserDetails[0]} isPasswordProvided={false} />)
    }
    else if (newUserDetails[0]?.isWebviewUser && !newUserDetails[0]?.isNewOrginization && newUserDetails[0]?.isUserActivated && !newUserDetails[0]?.isAdminApproved) {
      return (<ProspectClientInformation userDetails={newUserDetails[0]} isPasswordProvided={false} />)
    }
    else if (newUserDetails[0]?.isUserActivated && newUserDetails[0]?.isClientInfoConfirmed) {
      return (<ProfileData userDetails={newUserDetails[0]} isConfirmed={false} />)
    }
    else if (newUserDetails[0]?.isWebviewUser && !newUserDetails[0]?.isNewOrginization && newUserDetails[0]?.isUserActivated) {
      return (<ProfileData userDetails={newUserDetails[0]} isConfirmed={false} />)
    } else if (newUserDetails[0]?.isMultiBranch === null || newUserDetails[0]?.isMultiBranch === undefined && newUserDetails[0]?.prospectEmailAddress?.length) {
      return (<ProfileData userDetails={newUserDetails[0]} isConfirmed={false} />)
    }
    else if (isValidUser === false) {
      return (
        <LogoutSignin userName={userName} />
      )
    }
    else if (isValidUser == true) {
      return (
        <Grid container className="App">
          <Grid item xs={12}>
            <Header />
          </Grid>
          <Grid item xs={12}>
            <Content />
          </Grid>
        </Grid>)
    }
  }
  else {
    return (<Login isLoading={isDisable} />)
  }
}

export default App